import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

type LoaderProps = {
  show?: boolean;
  text?: string;
};

const Loader = ({ show = false, text }: LoaderProps) => {
  const [loaderRoot, setLoaderRoot] = useState<HTMLElement>();

  useEffect(() => {
    const root = document.getElementById('loader-root');
    if (root) {
      setLoaderRoot(root);
    }
  }, []);

  if (!show || !loaderRoot) {
    return <></>;
  }

  return ReactDOM.createPortal(
    <div className="mfone-loader-backdrop">
      <div className="mfo-router-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {text && <div className="text-white">{text}</div>}
    </div>,
    loaderRoot
  );
};

export default Loader;
